/**
 * Created by pandemio on 3/25/19.
 */
import React from 'react';
import {Input, Row, Col, Alert, Button, Label, FormGroup} from 'reactstrap';
import ApiCalls from '../../custom-classes/api-calls';
/** Multiple Language imports **/
import {Translate} from "react-localize-redux";
/** End of Multiple Language imports **/
import SelectorCurrency from '../selectors/selector-currency';
import DatePicker from '../date-picker/date-picker-recent';
import ModalGeneric from '../modals/modal-generic';
import LoaderFullWindow from '../loader-windows/loader-full-window';
import moment from 'moment';
/**
 * Creates or edit a coupon
 */
class FormCouponManager extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            name: props.coupon !== null && typeof props.coupon.Name !== 'undefined' ? props.coupon.Name : '',
            code: props.coupon !== null && typeof props.coupon.Code !== 'undefined' ? props.coupon.Code : '',
            currency: props.coupon !== null && typeof props.coupon.Currency !== 'undefined' ? props.coupon.Currency : null,
            percentOff: props.coupon !== null && typeof props.coupon.PercentOff !== 'undefined' ? props.coupon.PercentOff : '',
            amountOff: props.coupon !== null && typeof props.coupon.AmountOff !== 'undefined' ? props.coupon.AmountOff : '',
            duration: props.coupon !== null && typeof props.coupon.Duration !== 'undefined' ? props.coupon.Duration : null,
            durationInMonths: props.coupon !== null && typeof props.coupon.DurationInMonths !== 'undefined'
                ? props.coupon.DurationInMonths : '',
            maxRedemptions: props.coupon !== null && typeof props.coupon.MaxRedemptions !== 'undefined'
                ? props.coupon.MaxRedemptions : '',
            redeemBy: props.coupon !== null && typeof props.coupon.RedeemBy !== 'undefined'
                ? moment(props.coupon.RedeemBy) : null,
            available:  props.coupon !== null && typeof props.coupon.Available !== 'undefined'
                ? props.coupon.Available : "0",
            percentOrAmount: props.coupon !== null && typeof props.coupon.AmountOff !== 'undefined'
                && props.coupon.AmountOff !== null
                ? 'amount' : 'percent',
            valid: true,
            loading: false,
            showModal: false,
            propsModal: null
        }; // Default value

        this.handleCouponSubmit = this.handleCouponSubmit.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleCodeChange = this.handleCodeChange.bind(this);
        this.handleDuration = this.handleDuration.bind(this);
        this.handleDurationInMonths = this.handleDurationInMonths.bind(this);
        this.handleMaxRedemptions = this.handleMaxRedemptions.bind(this);
        this.handleSetRedeemBy = this.handleSetRedeemBy.bind(this);
        this.handleAvailable = this.handleAvailable.bind(this);
        this.handleAmountOrPercent = this.handleAmountOrPercent.bind(this);
        this.handleAmountOff = this.handleAmountOff.bind(this);
        this.handlePercentOff = this.handlePercentOff.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param props
     */
    componentWillReceiveProps(props) {

        if(typeof props.coupon !== 'undefined' && props.coupon !== null)
        {
            this.setState({
                name: props.coupon !== null && typeof props.coupon.Name !== 'undefined' ? props.coupon.Name : '',
                code: props.coupon !== null && typeof props.coupon.Code !== 'undefined' ? props.coupon.Code : '',
                currency: props.coupon !== null && typeof props.coupon.Currency !== 'undefined' ? props.coupon.Currency : null,
                percentOff: props.coupon !== null && typeof props.coupon.PercentOff !== 'undefined' ? props.coupon.PercentOff : '',
                amountOff: props.coupon !== null && typeof props.coupon.AmountOff !== 'undefined' ? props.coupon.AmountOff : '',
                duration: props.coupon !== null && typeof props.coupon.Duration !== 'undefined' ? props.coupon.Duration : null,
                durationInMonths: props.coupon !== null && typeof props.coupon.DurationInMonths !== 'undefined'
                    ? props.coupon.DurationInMonths : '',
                maxRedemptions: props.coupon !== null && typeof props.coupon.MaxRedemptions !== 'undefined'
                    ? props.coupon.MaxRedemptions : '',
                redeemBy: props.coupon !== null && typeof props.coupon.RedeemBy !== 'undefined'
                    ? moment(props.coupon.RedeemBy) : null,
                available:  props.coupon !== null && typeof props.coupon.Available !== 'undefined'
                    ? props.coupon.Available : "0",
                percentOrAmount: props.coupon !== null && typeof props.coupon.AmountOff !== 'undefined'
                && props.coupon.AmountOff !== null
                    ? 'amount' : 'percent',
                valid: true,
                });
        }
    }

    handleAvailable(){
        let value = "0";
        if(this.state.available === "0" || this.state.available === null)
            value = "1";
        else
            value = "0";

       this.setState({
           available:value
       })
    }

    handleNameChange(e){
        this.setState({
            name: e.target.value
        })
    }

    handleCodeChange(e){
        this.setState({
            code: e.target.value
        });
    }

    handleDuration(e){
        this.setState({
            duration: e.target.value
        },()=>{
            if(this.state.duration !== 'repeating')
            {
                this.setState({durationInMonths: ''});
            }
        });
    }

    handleDurationInMonths(e){
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({
                durationInMonths: e.target.value
            });
        }
    }

    handleMaxRedemptions(e){
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({
                maxRedemptions: e.target.value
            });
        }
    }

    handleSetRedeemBy(e){
        this.setState({
            redeemBy: e.date
        });
    }

    /**
     * Handles the coupon submition
     */
    handleCouponSubmit() {

        this.setState({
            loading: true,
            valid: true
        },()=>{
            // Validate
            if (
                this.state.name === null
                || this.state.name.trim().length === 0
                || this.state.code === null
                || this.state.code.trim().length === 0
                || this.state.duration === null
                ||
                (
                    this.state.duration === "repeating"
                    && (this.state.durationInMonths === null || this.state.durationInMonths === '')
                )
                || this.state.maxRedemptions === null
                || this.state.maxRedemptions.trim().length === 0
                || this.state.redeemBy === null

                || (
                    this.state.percentOrAmount === "amount" &&
                    (
                        this.state.currency === null
                        || this.state.currency === ""
                        || this.state.amountOff === null
                        || this.state.amountOff === ''
                        || parseInt(this.state.amountOff) === 0
                    )
                )
                ||
                (
                    this.state.percentOrAmount === "percent"
                    &&
                    (
                        this.state.percentOff === null
                        || this.state.percentOff === ''
                        || parseInt(this.state.percentOff) === 0)
                )
                ) {
                    this.setState({

                        valid: false,
                        loading: false
                    });
            }
            else {

                let apiCalls = ApiCalls.createCoupon(
                    this.state.name, this.state.code,
                    this.state.currency, this.state.percentOff,
                    this.state.amountOff, this.state.duration,
                    this.state.durationInMonths, this.state.maxRedemptions,
                    this.state.redeemBy, this.state.available);

                apiCalls.then((data)=> {
                    this.setState({
                        loading: false
                    },()=>{
                        let messageStr = '';
                        for(let i=0; i < data.Messages.length;i++)
                        {
                            messageStr += data.Messages[i] + '<br/>';
                        }
                        let propsModal = {
                            bodyText: messageStr,
                            visible: true
                        };
                        this.setState({propsModal: propsModal, showModal: true})
                    });
                });
            }
        });

    }

    handleCurrencyChange(e){
        this.setState({
            currency: e
        });
    }

    handleAmountOrPercent(e){
        this.setState({
            percentOrAmount: e.target.value
        });
    }

    handlePercentOff(e){
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({
                percentOff: e.target.value,
                amountOff: ''
            });
        }
    }

    handleAmountOff(e){
        const re = /^[0-9]*$/;

        if (e.target.value === '' || re.test(e.target.value)) {

            this.setState({
                amountOff: e.target.value,
                percentOff: ''
            });
        }
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal(){
        this.setState({showModal: false});
    }


    // Render the form group
    render() {
        return (
            <div>
                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Label for="name">
                            * <Translate id="coupons-manager.name" options={{renderInnerHtml: true}}/>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="coupons-manager.name-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <Input value={this.state.name}
                               type="text"
                               name="name"
                               id="name"
                               maxLength={20}
                               onChange={this.handleNameChange}/>
                        <br/>
                        {
                           (this.state.name === null ||  this.state.name.trim().length === 0) ?
                                <Alert color="danger">
                                    <Translate id="coupons-manager.name-required" options={{renderInnerHtml: true}}/>
                                </Alert> : null
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Label for="code">
                            * <Translate id="coupons-manager.code" options={{renderInnerHtml: true}}/>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="coupons-manager.code-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <Input value={this.state.code}
                               type="text"
                               name="code"
                               id="code"
                               maxLength={10}
                               onChange={this.handleCodeChange}/>
                        <br/>
                        {
                            (this.state.code === null ||  this.state.code.trim().length === 0) ?
                                <Alert color="danger">
                                    <Translate id="coupons-manager.code-required" options={{renderInnerHtml: true}}/>
                                </Alert> : null
                        }
                    </Col>
                </Row>

                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Label for="duration">
                            * <Translate id="coupons-manager.duration" options={{renderInnerHtml: true}}/>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="coupons-manager.duration-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <Input value={this.state.duration} type="select" name="select" id="duration" onChange={this.handleDuration}>
                            <option>----</option>
                            <option value="once">once</option>
                            <option value="forever">forever</option>
                            <option value="repeating">repeating</option>
                        </Input>
                        <br/>
                        {
                            (this.state.duration === null ||  this.state.duration.trim().length === 0) ?
                                <Alert color="danger">
                                    <Translate id="coupons-manager.duration-required" options={{renderInnerHtml: true}}/>
                                </Alert> : null
                        }
                    </Col>
                </Row>
                {this.state.duration === 'repeating' ?
                    <Row>
                        <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                            <Label for="duration-months">
                                * <Translate id="coupons-manager.duration-in-months" options={{renderInnerHtml: true}}/>
                            </Label>
                            <br/>
                            <small>
                                <Translate id="coupons-manager.duration-in-months-instructions"
                                           options={{renderInnerHtml: true}}/>
                            </small>
                            <Input value={this.state.durationInMonths}
                                   type="number"
                                   name="duration-months"
                                   id="duration-months"
                                   maxLength={2}
                                   onChange={this.handleDurationInMonths}/>
                            <br/>
                            {
                                (this.state.durationInMonths === null ||  this.state.durationInMonths.trim().length === 0) ?
                                    <Alert color="danger">
                                        <Translate id="coupons-manager.duration-in-months-required"
                                                   options={{renderInnerHtml: true}}/>
                                    </Alert> : null
                            }
                        </Col>
                    </Row> : null
                }

                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Label for="max-redemptions">
                            * <Translate id="coupons-manager.max-redemptions" options={{renderInnerHtml: true}}/>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="coupons-manager.max-redemptions-instructions"
                                       options={{renderInnerHtml: true}}/>
                        </small>
                        <Input value={this.state.maxRedemptions}
                               type="number"
                               name="max-redemptions"
                               id="max-redemptions"
                               maxLength={5}
                               onChange={this.handleMaxRedemptions}/>
                        <br/>
                        {
                            (this.state.maxRedemptions === null ||  this.state.maxRedemptions.trim().length === 0) ?
                                <Alert color="danger">
                                    <Translate id="coupons-manager.max-redemptions-required"
                                               options={{renderInnerHtml: true}}/>
                                </Alert> : null
                        }
                    </Col>
                </Row>
                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <Label for="redeem-by">
                            * <Translate id="coupons-manager.redeem-by" options={{renderInnerHtml: true}}/>
                        </Label>
                        <br/>
                        <small>
                            <Translate id="coupons-manager.redeem-by-instructions"
                                       options={{renderInnerHtml: true}}/>
                        </small>
                        <DatePicker date={this.state.redeemBy}
                                    updateParent={this.handleSetRedeemBy}/>
                        <br/>
                        {
                            (this.state.redeemBy === null) ?
                                <Alert color="danger">
                                    <Translate id="coupons-manager.redeem-by-required"
                                               options={{renderInnerHtml: true}}/>
                                </Alert> : null
                        }
                    </Col>
                </Row>

                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" checked={this.state.available === "1"}
                                       onChange={this.handleAvailable}/>{' '}
                                * <Translate id="coupons-manager.available" options={{renderInnerHtml: true}}/>
                                {' '}
                                <small>
                                    <Translate id="coupons-manager.available-instructions"
                                               options={{renderInnerHtml: true}}/>
                                </small>
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                    <FormGroup tag="fieldset">
                            <Translate id="coupons-manager.amount-or-percent"
                                       options={{renderInnerHtml: true}}/>
                        <FormGroup check>
                            <Label check>
                                <Input type="radio" name="percentage"
                                       value="percent"
                                       checked={this.state.percentOrAmount === "percent"}
                                       onChange={this.handleAmountOrPercent}
                                />{' '}
                                <Translate id="coupons-manager.percent-off"
                                           options={{renderInnerHtml: true}}/>{' '}

                            </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input type="radio" name="amount"
                                       value="amount"
                                       checked={this.state.percentOrAmount === "amount"}
                                       onChange={this.handleAmountOrPercent}
                                />{' '}
                                <Translate id="coupons-manager.amount-off"
                                           options={{renderInnerHtml: true}}/>{' '}
                            </Label>
                        </FormGroup>
                    </FormGroup>
                    </Col>
                </Row>

                {
                    this.state.percentOrAmount === "percent" ?
                    <Row>
                        <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                            <Label for="discount">
                                * <Translate id="coupons-manager.discount" options={{renderInnerHtml: true}}/>
                            </Label>
                            <br/>
                                <small><Translate id="coupons-manager.percent-off-instructions"
                                                  options={{renderInnerHtml: true}}/>{' '}
                                </small>
                            <Input value={this.state.percentOff}
                                   type="number"
                                   name="percentOff"
                                   id="percentOff"
                                   maxLength={3}
                                   onChange={this.handlePercentOff}/>
                            <br/>
                            {
                                (this.state.percentOff === null ||  this.state.percentOff.trim().length === 0) ?
                                    <Alert color="danger">
                                        <Translate id="coupons-manager.discount-required"
                                                   options={{renderInnerHtml: true}}/>
                                    </Alert> : null
                            }
                        </Col>
                    </Row> :
                        <Row>
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <Label for="currency">
                                    * <Translate id="coupons-manager.currency" options={{renderInnerHtml: true}}/>
                                </Label>
                                <br/>
                                <small><Translate id="coupons-manager.currency-instructions"
                                                  options={{renderInnerHtml: true}}/>{' '}
                                </small>
                                <SelectorCurrency disabled={false} value={this.state.currency}
                                                  updateParent={this.handleCurrencyChange}/>
                            </Col>
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <Label for="discount">
                                    * <Translate id="coupons-manager.discount" options={{renderInnerHtml: true}}/>
                                </Label>
                                <br/>
                                <small><Translate id="coupons-manager.amount-off-instructions"
                                                  options={{renderInnerHtml: true}}/>{' '}
                                </small>
                                <Input value={this.state.amountOff}
                                       type="number"
                                       name="amountOff"
                                       id="amountOff"
                                       maxLength={5}
                                       onChange={this.handleAmountOff}/>
                                <br/>
                                {
                                    (this.state.amountOff === null ||  this.state.amountOff.trim().length === 0) ?
                                        <Alert color="danger">
                                            <Translate id="coupons-manager.discount-required"
                                                       options={{renderInnerHtml: true}}/>
                                        </Alert> : null
                                }
                            </Col>
                        </Row>
                }
                <Row>
                    <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                        {
                            !this.state.valid?
                                <Alert color="danger">
                                    <Translate id="coupons-manager.submit-error"
                                               options={{renderInnerHtml: true}}/>
                                </Alert> : null
                        }
                        <Button color="success" onClick={this.handleCouponSubmit}>
                            <Translate id="coupons-manager.submit"
                                       options={{renderInnerHtml: true}}/>
                        </Button>
                    </Col>
                </Row>

                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showModal ?
                    <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}

            </div>
        )
    };
}

export default FormCouponManager;